import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ErrorInterceptor } from './helper/Interceptor/error.interceptor';
import { HttpCallHandleService } from './helper/Interceptor/http-call-handle.service';
import { JWTInterceptor } from './helper/Interceptor/jwt.interceptor';
import { AuthService } from './helper/service/auth.service';
import { searchModal } from './shared/interface/modal-interface';
import { WidgetModule } from "./modules/component/widget/widget.module";
import { TokenDisplayComponent } from './layouts/token-display/token-display.component';
import { LicensePageComponent } from './layouts/license-page/license-page.component';

@NgModule({
    declarations: [
        AppComponent, routingComponents, TokenDisplayComponent, LicensePageComponent
    ],
    providers: [
        HttpCallHandleService,
        AuthService,
        MessageService,
        { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        ToastModule,
        CoreModule,
        ModalModule.forRoot(),
        BrowserAnimationsModule,
        WidgetModule
    ]
})
export class AppModule { }
